/* src/app/features/prestacao-informacoes/acompanhamento-depr/acompanhamento-depr-cadastro/aba-documento/aba-documento.component.scss */
/*# sourceMappingURL=aba-documento.component.css.map */
